import { Stack, Text } from '@ekhodealer/ekho-common/rev';

interface SetupHeaderProps {
	title: string;
	details: string | string[];
}

/**
 * Shared header component for setup pages
 * Standardizes the title and detail text layout
 */
export function SetupHeader({ title, details }: SetupHeaderProps) {
	const detailsArray = Array.isArray(details) ? details : [details];

	return (
		<Stack itemsSpacing='16'>
			<Text size='title200' weight='bold'>
				{title}
			</Text>
			{detailsArray.map((detail, index) => (
				<Text key={index} size='bodySmall' weight='regular'>
					{detail}
				</Text>
			))}
		</Stack>
	);
}

